import type { ENVType } from '@/types/ENV'

export default {
  APP_URL: 'https://solaire-control-hub-rbac.solaireresort.com/',

  // make sure to end url with a '/'
  API_URL: 'https://apik-api.solaireresort.com/rbac-solaire-control-hub/',
  MSAL_TENANT_ID: '9c1d6af6-94df-4a4c-9b70-26edaee05a21',
  MSAL_CLIENT_ID: 'cec43437-c1b6-4e5a-9c69-4e9890ab3642',
  MSAL_REDIRECT_URI: '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: '/',
  TOKEN_API_URL: 'https://apik-api.solaireresort.com/api/v1.0/auth/oauth2/token',
  TOKEN_API_CLIENT_ID: import.meta.env.VITE_RBAC_CONTROL_HUB_TOKEN_API_CLIENT_ID ?? '',
  TOKEN_API_CLIENT_SECRET: import.meta.env.VITE_RBAC_CONTROL_HUB_TOKEN_API_CLIENT_SECRET ?? '',
  USE_KONG_API: true
} as ENVType
